import {
  IonButton,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonCol,
  IonContent,
  IonGrid,
  IonInput,
  IonNote,
  IonRow,
  useIonToast,
} from "@ionic/react";
import { useState } from "react";
import { useAuth } from "./auth/AuthContext";

import "./Login.css";
import { useHistory } from "react-router";

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  let { logIn } = useAuth()!;

  const history = useHistory();
  const [present] = useIonToast();

  async function loginUser() {
    logIn(email, password).then((success) => {
      success
        ? history.replace("/page/Dashboard")
        : history.replace("/page/Login");
      present({
        message: success ? "Welcome " + email : "Invalid Credentials!",
        duration: 2000,
      });
    });
  }

  function registerUser() {
    present({
      message: "Contact us for the Invite: https://www.renon.in/contact",
      duration: 2000,
    });
  }

  return (
    <IonContent fullscreen>
      <IonGrid>
        <IonRow className="customCenter">
          <IonCol sizeXs="1" sizeMd="3"></IonCol>
          <IonCol sizeXs="10" sizeMd="6">
            <IonCard color="light">
              <IonCardHeader>
                <img
                  className="ion-padding-bottom"
                  src="./assets/brand/renon-logo.png"
                  width={128}
                />
                <IonCardTitle>
                  Welcome to <b>ARMOR</b>
                </IonCardTitle>
                <IonCardSubtitle>
                  The Battery Lifecycle Management Platform
                </IonCardSubtitle>
              </IonCardHeader>

              <IonCardContent>
                <IonRow className="h-100 d-flex ion-justify-content-center ion-align-items-center">
                  <IonInput
                    placeholder="Email@company.com"
                    type="email"
                    onIonChange={(e: any) => setEmail(e.target.value)}
                  />
                </IonRow>
                <IonRow className="justify-content-center align-items-center">
                  <IonInput
                    placeholder="Password"
                    type="password"
                    onIonChange={(e: any) => setPassword(e.target.value)}
                  />
                </IonRow>
                <IonButton fill="outline" onClick={loginUser}>
                  Login
                </IonButton>
                <br />
                <IonNote className="ion-padding-top">
                  New to <b>ARMOR</b>? Know more{" "}
                  <a target="_" href="https://www.renon.in/software/renon360">
                    here
                  </a>
                  <br />
                  <a onClick={registerUser}>SignUp</a> here
                </IonNote>
              </IonCardContent>
            </IonCard>
          </IonCol>
          <IonCol sizeXs="1" sizeMd="3"></IonCol>
        </IonRow>
      </IonGrid>
    </IonContent>
  );
};

export default Login;
